
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

import ParameterItemGeneric from './ParameterItemGeneric';

const ParameterListBase = (props
    /* Note: do not remove this comment
    {
    generatePolygonDefinition,
    options,
    params,
    paramDefinitions,
    paramValues,
    tempFeature,
    onConfirm,
    onChangeValue,
    onSetGeometry,
    onSetIsGeoActive
    }
    */
) => {
    React.useEffect(() => {
        if (props.onSetIsGeoActive) {
            const isGeoActive = props.params.reduce((previous, current) => {
                return (current.type === 'GeomPolygon')
                    ? true
                    : previous;
            }, false);
            props.onSetIsGeoActive(isGeoActive);
        }
    }, [props.params]);

    const getOptions = (item) => {
        let options = cloneDeep(item.options);
        if (item.allowAll) {
            if (!options) {
                options = {};
            }
            set(options, 'ComboBox.emptyValue', {key: '', text: '<<vše>>'})
        }
        return options;
    }

    return props.params.filter(item => (item.hidden !== true)).map(item => {
        return (
            <ParameterItemGeneric
                {...props}
                key={item.id}
                id={item.id}
                options={getOptions(item)}
                title={item.title}
                type={item.type}
                value={props.paramValues[item.id]}
                values={item.values}
            />
        );
    });
}

export default ParameterListBase;
